import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { cn } from "../lib/utils";

export default function DynamicTooltip({
  trigger = "hover", // 'click' or 'hover'
  position = "bottom", // 'top', 'bottom', 'left', 'right'
  content = "This is dynamic tooltip content.",
  className = ""
}) {
  const [visible, setVisible] = useState(false);

  const positionClasses = {
    top: "bottom-full mb-2 left-1/2 -translate-x-1/2",
    bottom: "top-full mt-2 left-1/2 -translate-x-1/2",
    left: "right-full mr-2 top-1/2 -translate-y-1/2",
    right: "left-full ml-2 top-1/2 -translate-y-1/2",
    bottomLeft: "top-full mt-2 left-0 -translate-x-0",
    bottomRight: "top-full mt-2 right-0 -translate-x-0",
  };

  const triggerProps =
    trigger === "hover"
      ? { className: "group relative inline-block" }
      : { className: "relative inline-block" };

  return (
    <div
      {...triggerProps}
      onMouseEnter={() => trigger === "hover" && setVisible(true)}
      onMouseLeave={() => trigger === "hover" && setVisible(false)}
    >
      <FontAwesomeIcon
        icon={faInfoCircle}
        className={cn("text-webPrimary hover:cursor-pointer dark:text-white ml-1", className)}
        onClick={() => {
          if (trigger === "click") setVisible((prev) => !prev);
        }}
      />

      {(trigger === "hover" || visible) && (
        <div
          className={`text-black dark:text-white absolute z-50 w-fit p-3 text-sm bg-background border rounded-lg shadow-lg transition-opacity duration-200
            ${positionClasses[position] || positionClasses.bottom}
            ${
              trigger === "hover"
                ? "opacity-0 pointer-events-none group-hover:opacity-100"
                : "opacity-100"
            }`}
        >
          {content}
        </div>
      )}
    </div>
  );
}
